import { RootState } from '@shared/types';
import { FavoriteObjectEntity } from '@features/favorites/types';

export const selectFavorites = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[objectEntity];
export const selectGetFavoritesStatus = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[`${objectEntity}GetStatus`];
export const selectAddFavoriteStatus = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[`${objectEntity}AddStatus`];
export const selectDeleteFavoriteStatus = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[`${objectEntity}DeleteStatus`];
export const selectGetFavoritesError = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[`${objectEntity}GetError`];
export const selectAddFavoriteError = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[`${objectEntity}AddError`];
export const selectDeleteFavoriteError = (objectEntity: FavoriteObjectEntity) => (state: RootState) =>
    state.common.favorites[`${objectEntity}DeleteError`];

export const selectIsSidebarCollapsed = (state: RootState) => state.common.isSidebarCollapsed;
export const selectIsSidebarCollapseBlocked = (state: RootState) => state.common.isSidebarCollapseBlocked;
